/** Single source for displayed / diagnostic app version. */
export const APP_VERSION = "1.1.1";
